import './index.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { Firebase, FirebaseContext } from './Firebase';
import * as serviceWorker from './serviceWorker';

// babel imports - to support old browers.
import "core-js/stable";
import "regenerator-runtime/runtime";

/*
https://www.robinwieruch.de/complete-firebase-authentication-react-tutorial#firebase-realtime-database-in-react
*/

const theme = createTheme({
  palette: {
    primary: {
      main: '#4caf50',
      contrastText: '#fff',
    },
    secondary: {
      main: '#f39a1a',
      contrastText: '#fff',
    },
  },
});

ReactDOM.render(
  <React.Fragment>
    <MuiThemeProvider theme={theme}>
      <FirebaseContext.Provider value={new Firebase()}>
        <App />
      </FirebaseContext.Provider>
    </MuiThemeProvider>
  </React.Fragment>,
  document.getElementById('root')
);

serviceWorker.unregister();